import { useGtm } from '@gtm-support/vue-gtm';

export default function gtmEventTracker(event, category, action, label, value = 1) {
  const gtm = useGtm();

  gtm.trackEvent({
    event,
    category,
    action,
    label,
    value,
  });
}
